import { useEffect, useState } from "react";
import { useMenuStore } from "store/menuStore";

/**
 * Gets current index of the selected menu section tab.
 */
export function useSectionTabIndex(): number {
	const { menu, selectedSection } = useMenuStore();

	const defaultIndex: number = selectedSection ? (menu?.sections.indexOf(selectedSection) ?? 0) : 0;

	const [tabIndex, setTabIndex] = useState<number>(defaultIndex);

	useEffect(() => {
		if (selectedSection && menu) {
			const newIndex = menu.sections.indexOf(selectedSection);
			setTabIndex(newIndex);
		}
	}, [selectedSection, menu]);

	return tabIndex;
}
